export const prepararCuerpoParaEnvio = (cuerpo: string): string => {
  if (cuerpo.includes("<html>")) {
    return cuerpo;
  }
  return `<html>${cuerpo}</html>`;
};
